var CustomFields = {

    init: function() {
        CustomFields.bindExtraCustomFields();
        CustomFields.bindDeleteImage();
        CustomFields.bindDownloadFile();
        CustomFields.bindDataSource();
        CustomFields.bindCustomFiles();
        Forms.bindDropzones();
    },

    bindDataSource: function() {

    },

    bindExtraCustomFields: function() {
        $('.extra-field-source').change(function() {
            var input = $(this);
            var fieldId = input.data('fieldid');
            var fieldKey = input.data('fieldkey');
            var valueArray = input.val();
            var data = $('#' + fieldKey + '-container :input').serialize() + '&values=' + valueArray;
            var container = $('#' + fieldKey + '-container');

            $.post('/custom-fields/' + fieldId, data ,function(response) {
                container.html(response);
            });
        });
    },

    bindDeleteImage: function() {
        $('.custom-image-delete').click(function(e) {
            var btn = $(this);
            var remove = confirm('Are you sure you want to remove this file?');
            if (remove) {
                var fileId = btn.data('file');
                var key = btn.data('key');

                $.get('/files/' + fileId + '/custom-delete?key=' + key, function(response) {
                    if (!response['success']) {
                        alert('Action failed. Please try again.');
                        return false;
                    }
                    alert('File successfully deleted.');
                    window.location.reload();
                });
            }
        });
    },

    bindDownloadFile: function() {
        $('.custom-file-download .fa-download').click(function(e) {
            var btn = $(this).parent();
            var download = confirm('Are you sure you want to download this file?');
            if (download) {
                var fileId = btn.data('file');
                var key = btn.data('key');

                /*
                $.get('/files/' + fileId + '/custom-download?key=' + key, function(response) {
                    if (!response['success']) {
                        alert('Action failed. Please try again.');
                        return false;
                    }
                    alert('File successfully downloaded.');
                    window.location.reload();
                });
                */
                window.location.href = '/files/' + fileId + '/download';
            }
        });
    },

    bindCustomFiles: function() {
        $('.custom-field-file .fa-remove').on('click', function() {
            var file = $(this).parents('.custom-field-file');
            var fileId = $(this).data('file');
            var key = $(this).data('key');
            var deletedFiles = $('#deletedFiles');
            //var starCardId = $(this).data('starcard');
            if (confirm('Are you sure you want to remove this file?')) {
                var id = $(this).attr('id');
                $('#file-' + id + '-input').attr('disabled', true);
                $(this).parent().hide();
                if (deletedFiles.val().length <= 0) {
                    deletedFiles.val(fileId);
                } else {
                    deletedFiles.val(deletedFiles.val() + ',' + fileId);
                }
            }
        });

        $('.image-rotate').click(function() {
            var btn = $(this);
            var sign = '';
            var direction = btn.data('direction');
            var input = $('#file-' + btn.data('image') + '-input');
            var currentAngle = input.val();
            if (currentAngle == 360 || currentAngle == -360) {
                currentAngle = 0;
            }
            input.attr('disabled', false);
            if (direction == 'acw') {
                sign = '-';
            }
            var image = $('#' + btn.data('image'));
            var angle = parseInt(currentAngle) + parseInt(sign.concat(90));
            input.val(angle);
            console.log(angle);
            //var css = 'transform: rotate(' + angle + 'deg)';
            image.css('-webkit-transform', 'rotate(' + angle + 'deg)');
            image.css('-moz-transform', 'rotate(' + angle + 'deg)');
            image.css('transform', 'rotate(' + angle + 'deg)');
        });


        $('.custom-field-file .fa-download').on('click', function() {
            var file = $(this).parents('.custom-field-file');
            window.location.href = '/files/' + file.data('file-id') + '/download';
        });
    },

};